/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const JA = {
  'action.accept': '受け入れる',
  'action.cancel': 'キャンセル',
  'action.delete': '削除',
  'action.duplicate': '複製',
  'action.export': 'エクスポート',
  'action.import': 'インポート',
  'action.new': '新規',
  'action.open': '開く',
  'action.print': '印刷',
  'action.publish': '公開',
  'action.rename': '名前を変更',
  'action.share': '共有',
  'appbar.back-to-map-list': 'マップリストに戻る',
  'appbar.button-signup': 'サインアップ',
  'appbar.shared-button': '共有',
  'appbar.tooltip-export': 'エクスポート',
  'appbar.tooltip-history': '変更履歴',
  'appbar.tooltip-info': '情報',
  'appbar.tooltip-print': '印刷',
  'appbar.tooltip-publish': '公開',
  'appbar.tooltip-redo': 'やり直し',
  'appbar.tooltip-save': '保存',
  'appbar.tooltip-shared': 'コラボレーション用に共有',
  'appbar.tooltip-signup': 'サインアップ',
  'appbar.tooltip-starred': 'お気に入り',
  'appbar.tooltip-undo': '元に戻す',
  'editor-panel.icon-title': 'アイコン',
  'editor-panel.link-panel-title': 'リンク',
  'editor-panel.note-panel-title': 'ノート',
  'editor-panel.tooltip-add-icon': 'アイコンを追加',
  'editor-panel.tooltip-add-link': 'リンクを追加',
  'editor-panel.tooltip-add-note': 'ノートを追加',
  'editor-panel.tooltip-add-relationship': '関係を追加',
  'editor-panel.tooltip-add-topic': 'トピックを追加',
  'editor-panel.tooltip-connection-color': '色',
  'editor-panel.tooltip-connection-color-default': 'デフォルト色',
  'editor-panel.tooltip-connection-style': '接続スタイル',
  'editor-panel.tooltip-connection-style-curved-thick': '太い曲線',
  'editor-panel.tooltip-connection-style-curved-thin': '細い曲線',
  'editor-panel.tooltip-connection-style-polyline': 'シンプルなポリライン',
  'editor-panel.tooltip-connection-style-polyline-curved': '曲線ポリライン',
  'editor-panel.tooltip-delete-topic': 'トピックを削除',
  'editor-panel.tooltip-topic-border-color': '境界線の色',
  'editor-panel.tooltip-topic-border-color-default': 'デフォルト境界線色',
  'editor-panel.tooltip-topic-fill-color': '塗りつぶし色',
  'editor-panel.tooltip-topic-fill-color-default': 'デフォルト塗りつぶし色',
  'editor-panel.tooltip-topic-font-bigger': '大きく',
  'editor-panel.tooltip-topic-font-bold': '太字',
  'editor-panel.tooltip-topic-font-color': '色',
  'editor-panel.tooltip-topic-font-color-default': 'デフォルト色',
  'editor-panel.tooltip-topic-font-italic': '斜体',
  'editor-panel.tooltip-topic-font-smaller': '小さく',
  'editor-panel.tooltip-topic-font-style': 'フォントスタイル',
  'editor-panel.tooltip-topic-share-ellipse': '楕円形',
  'editor-panel.tooltip-topic-share-line': '線形',
  'editor-panel.tooltip-topic-share-rectangle': '矩形',
  'editor-panel.tooltip-topic-share-rounded': '角丸形',
  'editor-panel.tooltip-topic-style': 'トピックスタイル',
  'editor.edit-description-mobile': 'モバイルデバイスでは限定的なマインドマップ編集機能がサポートされています。完全なエディター機能にはデスクトップブラウザを使用してください。',
  'editor.try-welcome': 'この編集スペースでは、マインドマップエディターの機能の一部をご紹介しています！',
  'editor.try-welcome-description': '無料で無制限のマインドマップを作成、共有、公開するためにサインアップしてください。',
  'editor.try-welcome-description-mobile': '無料で無制限のマインドマップを作成、共有、公開するためにサインアップしてください。モバイルデバイスでは限定的なマインドマップ編集機能がサポートされています。完全なエディター機能にはデスクトップブラウザを使用してください。',
  'editor.try-welcome-mobile': 'この編集スペースでは、マインドマップエディターの機能の一部をご紹介しています！',
  'icon-picker.show-images': '画像を表示',
  'link.help_text': 'アドレスが無効です',
  'link.placeholder': 'https://www.example.com',
  'shortcut-help-pane.action': 'アクション',
  'shortcut-help-pane.add-child': '子トピックを追加',
  'shortcut-help-pane.add-link': 'リンクを追加',
  'shortcut-help-pane.add-note': 'ノートを追加',
  'shortcut-help-pane.add-sibling': '兄弟トピックを追加',
  'shortcut-help-pane.cancel-text-changes': 'テキスト変更をキャンセル',
  'shortcut-help-pane.change-font-bold': 'テキストを太字に変更',
  'shortcut-help-pane.change-font-italic': 'テキストを斜体に変更',
  'shortcut-help-pane.collapse-children': '子要素を折りたたむ',
  'shortcut-help-pane.copy-and-text': 'トピックをコピー＆ペースト/マインドマップ画像をクリップボードにコピー。',
  'shortcut-help-pane.delete-topic': 'トピックを削除',
  'shortcut-help-pane.deselect-all-topics': 'すべてのトピックの選択を解除',
  'shortcut-help-pane.drag-disconnect': 'トピックを切断',
  'shortcut-help-pane.edit-multiline': '複数行トピックテキストを追加',
  'shortcut-help-pane.edit-topic': 'トピックテキストを編集',
  'shortcut-help-pane.edit-topic-key': 'F2またはダブルクリック',
  'shortcut-help-pane.navigation': 'ナビゲーション',
  'shortcut-help-pane.navigation-keys': '矢印キー',
  'shortcut-help-pane.overwrite-edit-topic': 'トピックテキストを上書き',
  'shortcut-help-pane.overwrite-edit-topic-key': '選択されたトピックで入力',
  'shortcut-help-pane.redo': '編集をやり直し',
  'shortcut-help-pane.save-changes': '変更を保存',
  'shortcut-help-pane.select-all-topics': 'すべてのトピックを選択',
  'shortcut-help-pane.select-topics': '複数のトピックを選択',
  'shortcut-help-pane.select-topics-keys': 'マウスクリック',
  'shortcut-help-pane.undo': '編集を元に戻す',
  'zoom-panel.tooltip-keyboard': 'キーボードショートカット',
  'zoom-panel.tooltip-zoom-in': 'ズームイン',
  'zoom-panel.tooltip-zoom-out': 'ズームアウト',
  'zoom-panel.tooltip-zoom-to-fit': 'フィット',
  'creator-info-pane.description': '説明',
  'creator-info-pane.creator': '作成者',
  TAB_TO_CREATE_CHILD: '子トピックを作成',
  ENTER_TO_CREATE_SIBLING: '兄弟トピックを作成',
  PLUS_TOOLTIP_CREATE_CHILD: '子トピックを作成',
  PLUS_TOOLTIP_CREATE_SIBLING: '兄弟トピックを作成',
  PASTE_AS_CHILD: 'Paste as child of selected topic',
  CLIPBOARD_NO_SELECTION: 'Select a topic first',
  DEEPLINK_COPIED: 'Link copied to clipboard',
};

export default JA;
